import React from "react";
import Navbar from "../components/Navbar";
import { Link } from "react-router-dom";
import Carousel from "../components/Carousel";
import DiscoverImage from "../assets/img/HomeP.png";
import AboutImage from "../assets/img/premium_photo-1682096259050-361e2989706d 1.png";
import HomeImage from "../assets/img/peintre-graphic.webp";
import Footer from "../components/Footer";
import { Helmet } from "react-helmet-async";

const Home = () => {
  return (
    <div className="home">
      <Helmet>
        <title>LM Couleurs – Peintre en bâtiment à Vannes</title>
        <meta
          name="description"
          content="Entreprise de peinture à Vannes et dans le Morbihan. Neuf & Rénovation, Papier peint, Enduit décoratif. Devis gratuit rapide avec LM Couleurs.."
        />
        <link rel="canonical" href="https://lmcouleurs.fr" />
        <meta
          property="og:title"
          content="LM Couleurs – Peintre en bâtiment à Vannes (Morbihan)"
        />
        <meta
          property="og:description"
          content="Travaux de peinture intérieure à Vannes et ses environs. Devis rapide et prestations soignées."
        />
        <meta property="og:url" content="https://lmcouleurs.fr/" />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content="https://lmcouleurs.fr/images/og-home.jpg"
        />
      </Helmet>

      <Navbar />
      <header>
        <h1>L'expertise à votre service</h1>
        <p>
          Artisan peintre indépendant, je donne vie à vos idées avec soin,
          précision et créativité.
        </p>
        <div className="header-btn">
          <Link to={"/services"} className="btn">
            Mes Services
          </Link>
          <Link to={"/contact"} className="btn" id="contact-btn">
            Devis gratuit
          </Link>
        </div>
      </header>
      <body>
        {/* <Carousel /> */}
        <div className="home-discover">
          <div className="home-discover-image">
            <img src={DiscoverImage} alt="Découvrir mes services" />
          </div>
          <div className="home-discover-text-container">
            <div className="home-discover-text">
              <h2>Découvrez notre savoir-faire en couleurs !</h2>
              <p>
                Peintre en bâtiment à Vannes et alentours <br />
                Travaux soignés, finitions propres, devis rapide
              </p>
              <p>
                J’accompagne particuliers et professionnels pour leurs travaux
                de peinture intérieure, avec un seul objectif : un rendu propre,
                durable et sans stress.
                <br />
              </p>

              <Link
                to="/FAQ"
                className="btn"
                onClick={() => window.scrollTo(0, 0)}
              >
                FAQ
              </Link>
            </div>
          </div>
        </div>
        <div className="home-about-section">
          <div className="home-about-text-container">
            <div className="home-about-text">
              <h2>À propos de LM Couleurs</h2>
              <p>
                J’interviens pour vos travaux de peinture intérieure et
                extérieure, en neuf comme en rénovation. Je mets un point
                d’honneur à travailler proprement, à respecter les délais
                annoncés et à laisser un chantier impeccable.
              </p>
              <p>
                Mon objectif est simple : que vous soyez serein pendant les
                travaux, et satisfait du résultat final.
              </p>
              <Link to={"/services#about"} className="btn">
                En savoir +
              </Link>
            </div>
          </div>
          {/* <div className="home-about-image">
            <img src={AboutImage} alt="À propos de moi" />
          </div> */}
        </div>
        <div className="home-services">
          <div className="neuf">
            <p>Neuf & Rénovation</p>
          </div>
          <div className="papier-peint">
            <p>Papier peint</p>
          </div>
          <div className="enduit">
            <p>Enduit Décoratif</p>
          </div>
          {/* <div className="mur">
            <p>Mur & Escalier</p>
          </div> */}
        </div>
        <div className="home-promesse">
          <div className="home-promesse-text-container">
            <div className="home-promesse-text">
              <h2>Ma promesse : un travail soigné & à votre écoute</h2>
              <p>
                Chaque projet mérite <strong>toute mon attention</strong>. En
                tant qu'artisan peintre indépendant, je{" "}
                <strong>m'engage</strong> à vous offir un accompagnement
                personnalisé, du premier contact jusqu'aux finitions.
              </p>
              <br />
              <p>
                Mon objectif est simple : réaliser un{" "}
                <strong>travail propre</strong>, durable et{" "}
                <strong>fidèle à vos attentes</strong>. Je privilégie la
                transparence, les conseils adaptés et le{" "}
                <strong>respect des délais</strong>. Parce qu'au-delà de la
                peinture, c'est votre confort et votre{" "}
                <strong>satisfaction</strong> qui comptent.
              </p>
              <Link to={"realisations"} className="btn">
                Mes réalisations
              </Link>
            </div>
          </div>
          <div className="home-promesse-image">
            <img src={HomeImage} alt="Ma promesse" />
          </div>
        </div>
      </body>
      <Footer />
    </div>
  );
};

export default Home;
